__turbopack_context__.v({
  "boldText": "MembersInviteDialog-module-scss-module__Wi7DSW__boldText",
  "content": "MembersInviteDialog-module-scss-module__Wi7DSW__content",
  "description": "MembersInviteDialog-module-scss-module__Wi7DSW__description",
  "dialog": "MembersInviteDialog-module-scss-module__Wi7DSW__dialog",
  "header": "MembersInviteDialog-module-scss-module__Wi7DSW__header",
});
